import React from "react";
import { Helmet } from "react-helmet";
import Store from "../store";
import Actions from "../actions";

import { publicUrl } from "../../../utils";
import getPlatformAlertView from "../../../helpers/platform-banners.jsx";

const env = process.env.CMC_PORTAL_ENV;
const STATIC_PAGE_PATH =
  process.env.CMC_PORTAL_STATIC_PAGE_ABSOLUTE_PATH || "/";
const AUTHENTICATED_PAGE_PATH =
  process.env.CMC_PORTAL_AUTHENTICATED_PAGE_ABSOLUTE_PATH || "/";

//api docs path has changed when accessed from static environment destinations
const DOCUMENTATION_PATH =
  STATIC_PAGE_PATH !== "/"
    ? STATIC_PAGE_PATH + "documentation/v1/"
    : "/api/v1/";

const SEO_BASE_URL = "https://coinmarketcap.com/api/";

class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = Store.getState();
  }

  async componentDidMount() {
    this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));
    Actions.fetchAlerts();
  }

  componentWillUnmount() {
    this.unsubscribeStore();
    Actions.resetStore();
  }

  onStoreChange() {
    this.setState(Store.getState());
  }

  render() {
    const topAlert = getPlatformAlertView(
      this.state.platformAlerts,
      Actions.hidePlatformAlert,
      true
    );

    if (env === "sandbox") {
      return (
        <main>
          {topAlert}
          <section className="section-home container">
            <Helmet>
              <title>
                Most Trusted Cryptocurrency Market Data API | CoinMarketCap
                Sandbox
              </title>
            </Helmet>

            <div className="jumbotron">
              <div className="container">
                <h1 className="display-5">
                  This is the API
                  <br />
                  Test Sandbox.
                </h1>
                <div className="sandbox-env-list">
                  <ol>
                    <li>
                      You may test any subscription tier for free in this demo
                      environment.
                    </li>
                    <li>
                      You should reference the{" "}
                      <a
                        rel="noopener noreferrer"
                        href={DOCUMENTATION_PATH}
                        target="_blank"
                      >
                        API Documentation
                      </a>{" "}
                      and use domain <b>sandbox-api.coinmarketcap.com</b> for
                      your test API calls.
                    </li>
                    <li>
                      You should be aware that test market data is not live data
                      in this testing sandbox.
                      <br />
                      <i>
                        /latest data endpoints will always return data from
                        2018-12-22.
                      </i>
                      <br />
                      <i>
                        /historical data endpoints are restricted to a period
                        from <br />
                        2018-12-19T00:04:01.000Z to 2018-12-22T06:04:02.000Z.
                      </i>
                    </li>
                    <li>
                      When you're ready to integrate live data, signup in the{" "}
                      <a href={SEO_BASE_URL}>production environment</a>.
                    </li>
                  </ol>
                </div>
                <p>
                  <a
                    className="btn btn-primary btn-lg"
                    href={AUTHENTICATED_PAGE_PATH + "signup/"}
                  >
                    Get a test API Key
                  </a>
                </p>
              </div>
            </div>
          </section>
        </main>
      );
    }

    return (
      <main>
        {topAlert}
        <section className="section-home container">
          <Helmet>
            <title>
              Most Trusted Cryptocurrency Market Data API | CoinMarketCap
            </title>
            <link rel="canonical" href={SEO_BASE_URL}></link>
          </Helmet>

          <div className="jumbotron">
            <div className="container">
              <h1 className="display-5">
                The world's cryptocurrency data authority has a professional API
                made for you.
              </h1>
              <p>
                <a
                  style={{ marginRight: "10px" }}
                  className="btn btn-primary btn-lg"
                  href={AUTHENTICATED_PAGE_PATH + "signup/"}
                >
                  Get Your API Key Now
                </a>

                <a
                  className="btn btn-primary btn-lg"
                  href={AUTHENTICATED_PAGE_PATH + "features/"}
                >
                  Compare API Plans
                </a>
              </p>
            </div>
          </div>

          <div className="customer-logos">
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Coinbase.svg`)}
                alt="Coinbase"
              />
            </div>
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Samsung.svg`)}
                alt="Samsung"
              />
            </div>
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Opera.svg`)}
                alt="Opera"
              />
            </div>
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Binance.svg`)}
                alt="Binance"
                style={{ width: "170px" }}
              />
            </div>
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Chainalysis.png`)}
                alt="Chainalysis"
              />
            </div>
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Chainlink.png`)}
                alt="Chainlink"
              />
            </div>
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Google.png`)}
                alt="Google"
              />
            </div>
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Huobi.png`)}
                alt="Huobi"
              />
            </div>
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Microsoft.png`)}
                alt="Microsoft"
              />
            </div>
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Trust Wallet.png`)}
                alt="Trust Wallet"
                style={{ maxHeight: "80px" }}
              />
            </div>
            <div>
              <img
                src={publicUrl(`/media/img/customer-logos/Yahoo.png`)}
                alt="Yahoo"
              />
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="fa fa-sliders"></div>
                <p>
                  A new suite of powerful, flexible, and accurate cryptocurrency
                  market data endpoints.
                </p>
              </div>
              <div className="col-md-4">
                <div className="fa fa-edit"></div>
                <p>
                  From demanding enterprise use cases to economical pricing
                  plans for startups, there is a plan for you.
                </p>
              </div>
              <div className="col-md-4">
                <div className="fa fa-trophy"></div>
                <p>
                  Created by the most trusted cryptocurrency market data
                  provider in the industry.
                </p>
              </div>
            </div>
            <div className="row">
              <h2 className="border-top">
                Your private key for all crypto use cases.
              </h2>
              <div className="col-md-6">
                <h3 className="text-center">Backtest your strategies</h3>
                <p>
                  Use the best possible crypto data to run simulations and
                  backtest your trading or investing strategies. With data
                  aggregated from hundreds of exchanges and thousands of coins,
                  you can be sure that you&apos;re getting the right picture
                  every single time.
                </p>
                <p>
                  All time historical data available on our Enterprise plan,
                  ensuring that you have full visibility of all cryptocurrency
                  data since 2013.
                </p>
              </div>
              <div className="col-md-6">
                <h3 className="text-center">Chart the right data</h3>
                <p>
                  Show your users the most accurate data on the market with our
                  API. Whether you&apos;re building a wallet, a portfolio
                  management tool, a new media offering, or more, we have the
                  most advanced and updated data on the market for your product.
                </p>
                <small>
                  <i>(only available on Standard and Professional plans)</i>
                </small>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <h3 className="text-center">Beat the competition</h3>
                <p>
                  Check in on how other exchanges and coins are doing with our
                  markets data. With deep insight into current and past pricing,
                  volume and exchange info, you can make the right decisions to
                  stay ahead of the game.
                </p>
              </div>
              <div className="col-md-6">
                <h3 className="text-center">Run experiments</h3>
                <p>
                  Build your own models with our data, to further your interest
                  or just for fun. With our flexible and powerful API, we
                  provide you with a set of data that will help you draw
                  insights and make conclusions.
                </p>
              </div>
            </div>
            <div className="row column-details">
              <p>
                <a
                  className="btn btn-primary btn-lg"
                  href={STATIC_PAGE_PATH + "pricing/"}
                >
                  View Plans
                </a>
              </p>
            </div>
            <div
              className="row column-details new-features-coming-soon"
              id="newsletter-signup"
            >
              <h2 className="border-top coming-soon">
                More new features coming soon.
              </h2>
              <div className="cmc_emaildescription">
                Subscribe to stay up-to-date on Pro API feature updates
              </div>
              <div
                className="signup-form"
                dangerouslySetInnerHTML={{
                  __html:
                    '<script type="text/javascript" src="//app.sgwidget.com/js/sg-widget-v2.js"></script><style>.sendgrid-subscription-widget input { padding: .5em .5em .55em; font-size: .8em; font-family: sans-serif } .sendgrid-subscription-widget .sg_signup_first_name, .sendgrid-subscription-widget .sg_signup_last_name { margin-right: .5em } .sendgrid-subscription-widget .sg-submit-btn { display: inline-block; color: #444; border: 1px solid #ccc; background: #ddd; box-shadow: 0 0 5px -1px rgba(0, 0, 0, .2); cursor: pointer; vertical-align: middle; max-width: 100px; padding: .5em; margin: 0 .4em; text-align: center; font-size: .9em; font-family: sans-serif } .sendgrid-subscription-widget .sg-submit-btn:active { color: #8e8b8b; box-shadow: 0 0 5px -1px rgba(0, 0, 0, .6) } .sendgrid-subscription-widget .response { display: none; font-family: sans-serif; font-size: .8em } .sendgrid-subscription-widget .success { color: green } .sendgrid-subscription-widget .error, .sendgrid-subscription-widget .sg-consent-text a { color: #3097d1 } .sendgrid-subscription-widget .sg-consent-text { font-size: .9em } .sendgrid-subscription-widget .sg-consent-text label { font-weight: 400 } .sendgrid-subscription-widget .required { outline: 1px solid #f00; } .sendgrid-subscription-widget .sg_custom { margin-left: 5px; } .sendgrid-subscription-widget .checkbox_label { padding-left: 3px; } </style><div class="sendgrid-subscription-widget widget-1117" data-emailerror="Please enter a valid email address" data-nameerror="Please enter your name" data-checkboxerror="Please tick the box to accept our conditions"><form class="sg-widget" data-token="a7232c67c0a2dff8e799520b1e3de44b" onsubmit="return false;"><div class="sg-response"></div><input class="sg_email" type="email" name="sg_email" placeholder="you@example.com" required="required"> <input type="submit" class="sg-submit-btn" id="widget-1117" value="Subscribe"></form></div>',
                }}
              />
              <div className=""></div>
              <ul>
                <li>Live price streaming</li>
                <li>Social data</li>
                <li>News data</li>
                <li>Whitepaper search</li>
                <li>Charts snapshot</li>
                <li>Most watchlisted</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./client/pages/main/home/index.jsx